import { Link } from "react-router-dom";
import { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Button, CardActionArea, CardActions } from "@mui/material";

const ProjectCard = ({ img, title, path, subText }) => {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <li className="projects-card">
      <Card sx={{ maxWidth: 345, display: "inline-block" }}>
        <Link to={path} className="projects-card-link">
          <CardActionArea>
            <CardMedia component="img" height="200" image={img} alt="sec" />
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                {title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {showInfo ? subText : `${subText.substring(0, 89)}...`}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Link>
        <CardActions>
          <Button size="small" onClick={() => setShowInfo(!showInfo)}>
            {showInfo ? "Show less" : "Read more"}
          </Button>
        </CardActions>
      </Card>
    </li>
  );
};

export default ProjectCard;
